enum OrderItemTag {
    /** 抖店供应链商品项 */
    DOUDIAN_ORDER_SUPPLY = "DOUDIAN_ORDER_SUPPLY",
}

export default OrderItemTag;
